<h2 mat-dialog-title>Formaciones activas</h2>

<mat-dialog-content>
  <p>
    Vas a activar <strong>{{ new_resource_name }}</strong> y ya tienes otras formaciones activas.
  </p>
  <p>
    Lo recomendable es hacer <strong>un solo curso a la vez</strong>. Si vas a trabajar varios cursos en paralelo, mantén activas todas las
    matrículas que vayas a seguir usando.
  </p>

  <ul class="active-enrollments-list">
    @for (enrollment of active_enrollment_labels; track enrollment.id) {
      <li>
        <mat-checkbox [checked]="isEnrollmentSelected(enrollment.id)" (change)="toggleEnrollmentSelection(enrollment.id, $event.checked)">
          {{ enrollment.name }}
        </mat-checkbox>
      </li>
    }
  </ul>

  <p class="hint">Marca las matrículas que quieras desactivar o completar al activar el nuevo curso.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>

  <div class="primary-actions">
    <button mat-flat-button color="accent" type="button" (click)="closeSelected()" [disabled]="selected_enrollment_ids().size === 0">
      Activar y desactivar seleccionados
    </button>
    <button mat-icon-button type="button" [matMenuTriggerFor]="activationOptionsMenu" aria-label="Más opciones de activación">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #activationOptionsMenu="matMenu">
      <button mat-menu-item type="button" (click)="activateWithoutClosing()">Activar sin desactivar ninguna</button>
      <button mat-menu-item type="button" (click)="completeSelected()" [disabled]="selected_enrollment_ids().size === 0">
        Activar y completar (y desactivar) seleccionados
      </button>
    </mat-menu>
  </div>
</mat-dialog-actions>
